import { useEffect } from 'react';

const useTrackEvent = () => {
  useEffect(() => {
    if (typeof window !== 'undefined' && !window.dataLayer) {
      window.dataLayer = [];
    }
  }, []);

  const pushPageView = (event, flujo, step, page, pageName) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      const eventData = {
        event,
        flujo,
        step,
        page,
        PageName: pageName,
        version: 'v2',
      };

      window.dataLayer.push(eventData);
    }
  };

  const pushCustomEvent = (eventName, eventData = {}) => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        event: eventName,
        ...eventData,
      });
    }
  };

  return {
    pushPageView,
    pushCustomEvent,
  };
};

export default useTrackEvent;
